module.exports = __webpack_public_path__ + "static/media/PROCEDIMIENTODEFINITIVESCRITURACIÓN.fc86e3cf.pdf";